import React, { useState } from 'react'
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleProfileModal } from '../../../actions/navActions';

// Components - imported
import { Button } from '@material-ui/core';
import Logo from '../../common/Logo';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const Confirm = ({
    slideform2, 
    setSlideForm2,
    toggleProfileModal,
    user,
    handleGoBack,
    previousUrl
}) => {

    const [btnText, setBtnText] = useState('Continue');
    const [gotBtnText, setGotBtnText] = useState(false);

    // Go back to the previous form step
    const goBack = (e) => {
        setSlideForm2(!slideform2);
    }

    // Handle the action when confirming the profile update
    // (Close the edit profile modal && redirect to profile page)
    const todo = (e) => {
        // Close edit profile modal
        toggleProfileModal();

        // Redirect to the user's profile page
        window.location.href = `/user/${user._id}`;
    }

    if(!gotBtnText){
        if(previousUrl === 'create' || previousUrl === 'create_home' || previousUrl === 'create_detail' || previousUrl === 'create_profile' || previousUrl === 'comment') {
            setBtnText('Continue Posting');
        } else if(previousUrl === 'home'){
            setBtnText('Back to Home');
        } else if(previousUrl === 'profile'){
            setBtnText('Back to Profile');
        }
        
        setGotBtnText(true);
    }

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            <div onClick={goBack} className="form__backBtn">
                <ArrowBackIcon />
            </div>

            {/* Form Body */}
            <div style={{height: '75%', width:'fit-content', display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>

                {/* Logo */}
                <Logo />

                {/* Form Title */}
                <div style={{marginTop:'20px'}}>
                    <h2>Your profile is finished!</h2>
                </div>

                {/* Form Actions */}
                <div style={{width:'100%', marginTop:'10px'}}>

                    {/* Submit Button */}
                    <Button 
                        onClick={(e) => handleGoBack(e)}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        {btnText}
                    </Button>
                    {/* <Button 
                        variant="outlined" 
                        className="sidebar__tweet ghost" 
                        fullWidth
                        onClick={todo}
                    >
                        Go  to Profile
                    </Button> */}
                </div>
            </div>

        </div>
    )
}

Confirm.propTypes = {
    // Function to toggle the profile modal
    toggleProfileModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    toggleProfileModal 
})(Confirm);
